import script from "./P2pView.vue?vue&type=script&setup=true&lang=js"
export * from "./P2pView.vue?vue&type=script&setup=true&lang=js"

import "./P2pView.vue?vue&type=style&index=0&id=5dfa10c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dfa10c2"]])

export default __exports__